import { render, staticRenderFns } from "./SetLessonDialog.vue?vue&type=template&id=7c61de12&scoped=true&"
import script from "./SetLessonDialog.vue?vue&type=script&lang=js&"
export * from "./SetLessonDialog.vue?vue&type=script&lang=js&"
import style0 from "./SetLessonDialog.vue?vue&type=style&index=0&id=7c61de12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c61de12",
  null
  
)

export default component.exports